/**
 * Confirmation dialog shown when user edits the autoname field and saves.
 * Follows the same pattern as the delete confirmation in HeaderActions.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RenameConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  doctype: string;
  oldName: string;
  newName: string;
}

export function RenameConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  doctype,
  oldName,
  newName,
}: RenameConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Rename {doctype}?</DialogTitle>
          <DialogDescription>
            This will rename &ldquo;{oldName}&rdquo; to &ldquo;{newName}&rdquo;.
            Links in other documents will update automatically.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>
            Rename
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
